import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from './../../../../../_shared/model/customer.model';

@Component({
    selector: 'app-main-calendar-popup',
    templateUrl: './main-calendar-popup.component.html',
    styleUrls: ['./main-calendar-popup.component.scss'],
})
export class MainCalendarPopupComponent implements OnInit {
    @Input()
    selectedCustomerForNewTerm: Customer;

    @Input()
    canOpenTerm = true;

    @Input()
    canAddNewTerms = true;

    @Input()
    highlightTerm: Event;

    @Input()
    isReschedule = false;

    @Input()
    isCreateFromWaitingQueue = false;

    @Input()
    isCase = false;

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    genericData: any;

    @Input()
    isGetOnlySlot = false;

    @Input()
    connectTermWithWorkOrder = false;

    // @Input()
    // limitToSubcontractors: any[];

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private term: any;
    constructor(public activeModal: NgbActiveModal) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    public closeCalendar(): void {
        this.activeModal.close(this.term);
    }

    public closeCalendarWithEvent(event: Event): void {
        this.activeModal.dismiss(event);
    }

    public onChangeTerm(event): void {
        this.term = event;
    }
}
